import React, { FC } from "react";
import { TaskDetails } from "@dewo/app/graphql/types";
import { Button } from "antd";
import { TwitterOutlined } from "@ant-design/icons";
import slugify from "slugify";
import * as qs from "query-string";

interface Props {
  task: TaskDetails;
  heading?: string;
}

export const TaskTwitterShareButton: FC<Props> = ({
  task,
  heading = `🚨 Bounty Call 🚨`,
}) => {
  const text = `${heading}\n\n${task.name}\n\nCheck out the details👇\n${task.permalink}\n`;
  const hashtags = task.tags
    .map((t) => slugify(t.label))
    .concat("dework")
    .join();
  return (
    <Button
      title="Share on Twitter"
      type="text"
      target="_blank"
      name="Share on Twitter"
      size="large"
      icon={<TwitterOutlined />}
      href={`https://twitter.com/intent/tweet?${qs.stringify({
        text,
        hashtags,
      })}`}
    />
  );
};
